import React from 'react';
import InlineReference from './InlineReference';

class GoogleDriveReference extends React.Component {
    render() {
        return <InlineReference cssSelector="google-drive" {...this.props} />;
    }
}

export default GoogleDriveReference;
